import { render, staticRenderFns } from "./detailHtmlParts.vue?vue&type=template&id=5c79665a&"
import script from "./detailHtmlParts.vue?vue&type=script&lang=js&"
export * from "./detailHtmlParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports